import React, { useState } from 'react'

import { ColorPicker } from '@tribeplatform/react-ui-kit/ColorPicker'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'

import { T } from '../../i18n/components/T.js'
import { useStaticIntl } from '../../i18n/hooks/useStaticIntl.js'
import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { ColorModes } from '../types.js'
import { colorModesFactory } from '../utils/selectOptions.js'

interface Props {
  color: string
  setColor: (color: string) => void
}
export const ColorSettings = ({ color, setColor }: Props) => {
  const { $t } = useI18n()
  const colorModes = useStaticIntl(colorModesFactory)
  const [colorMode, setColorMode] = useState<ColorModes>(
    color ? ColorModes.custom : ColorModes.default,
  )

  return (
    <>
      <FormControl.Select
        value={colorMode}
        onChange={(newColorMode: ColorModes) => {
          setColorMode(newColorMode)
          if (newColorMode === ColorModes.default) {
            setColor('')
          }

          if (newColorMode === ColorModes.custom && !color) {
            setColor('#ff0000')
          }
        }}
        label={$t({
          defaultMessage: 'Color mode',
          id: 'Admin.CMS.Reactions.ColorMode',
        })}
        name="colorOption"
        items={colorModes}
      />
      {colorMode === ColorModes.custom && (
        <div className="flex items-center justify-between">
          <FormControl.Label>
            <T id="Generics.Color" defaultMessage="Color" />
          </FormControl.Label>
          <ColorPicker
            color={color}
            onChange={newColor => setColor(newColor)}
            shouldDebounce={false}
          />
        </div>
      )}
    </>
  )
}
